import { mediaGQLFields } from '../media/media.fields.js';
import { spaceGQLFields } from './space.fields.js';
const BASIC_PAGE_FIELDS = {};
const DEFAULT_PAGE_FIELDS = {
    space: 'default',
};
const ALL_PAGE_FIELDS = { space: 'basic' };
export const pageGqlFields = (fields = 'default') => {
    if (fields === 'default')
        fields = DEFAULT_PAGE_FIELDS;
    if (fields === 'all')
        fields = ALL_PAGE_FIELDS;
    if (fields === 'basic')
        fields = BASIC_PAGE_FIELDS;
    return `
    seoDetail {
      additionalMeta {
        type
        properties {
          key
          value
        }
      }
      description
      jsonld
      title
      thumbnail {
        ${mediaGQLFields()}
      }
    }
    ${fields.space
        ? `space {
      ${spaceGQLFields(fields.space)}
    }`
        : ''}
  `;
};
//# sourceMappingURL=page.fields.js.map